import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { Controller, useWatch } from "react-hook-form";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomTabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
};

function a11yProps(index: number) {
  return {
    id: `ws-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export interface TabData {
  label: string;
  content: React.ReactNode;
}

interface ControlledTabsProps {
  id: string;
  control: any;
  name: string;
  setValue?: any;
  defaultValue?: number;
  selectedTab?: number;
  onTabChange?: (value: number) => void;
  tabs: TabData[];
  justifyTabs?: "center" | "flex-start" | "flex-end" | "space-between";
}

export const WSTabs: React.FC<ControlledTabsProps> = ({
  control,
  name,
  defaultValue = 0,
  selectedTab,
  onTabChange,
  tabs,
  justifyTabs = "flex-start",
  setValue,
}) => {
  const currentValue = useWatch({ control, name });

  // Sync external tab control
  useEffect(() => {
    if (typeof selectedTab === "number" && selectedTab !== currentValue) {
      setValue(name, selectedTab);
    }
  }, [selectedTab]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => {
        const handleChange = (
          event: React.SyntheticEvent,
          newValue: number
        ) => {
          field.onChange(newValue);
          onTabChange?.(newValue);
        };

        return (
          <Box sx={{ width: "100%" }}>
            {}
            <Box
              sx={{
                display: "flex",
                justifyContent: justifyTabs,
              }}
            >
              <Tabs
                value={field.value}
                onChange={handleChange}
                TabIndicatorProps={{ style: { display: "none" } }} 
               sx={{
  minHeight: "auto",

  "& .MuiTabs-flexContainer": {
    gap: "12px", // 👈 THIS is where gap works
  },
}}
              >
                {tabs.map((tab, index) => (
                  <Tab
                    key={index}
                    label={tab.label}
                    {...a11yProps(index)}
                    disableRipple
                    sx={{
                      textTransform: "none",
                      fontSize: "0.9rem",
                      fontWeight: 500,
                      minHeight: "36px",
                      px: 2.5,
                      borderRadius: "20px",
                      backgroundColor: "#e5e7eb", // default gray
                      color: "#6b7280",
                      transition: "all 0.2s ease",

                      "&.Mui-selected": {
                        backgroundColor: "#2f2f2f", // active tab
                        color: "#fff",
                      },

                      "&:hover": {
                        backgroundColor: "#d1d5db",
                      },
                    }}
                  />
                ))}
              </Tabs>
            </Box>

            {}
            {tabs.map((tab, index) => (
              <CustomTabPanel
                key={index}
                value={field.value}
                index={index}
              >
                {tab.content}
              </CustomTabPanel>
            ))}
          </Box>
        );
      }}
    />
  );
};